import Hero from '../components/Hero'
import StreamingBar from '../components/StreamingBar'
import NewsSection from '../components/NewsSection'
import TourSection from '../components/TourSection'
import MusicSection from '../components/MusicSection'
import BookingCTA from '../components/BookingCTA'

export default function Home() {
  return (
    <main>
      <Hero />
      <StreamingBar />
      <NewsSection limit={3} />
      <TourSection limit={5} />
      <MusicSection limit={4} />
      <BookingCTA />
    </main>
  )
}
